<template>
    <Card class="layout-card">
        <Tabs v-model="tabIndex" @on-click="changeTab">
            <TabPane label="优化师" name="0">
            </TabPane>
            <TabPane label="广告系列" name="1">
            </TabPane>
            <TabPane label="广告组" name="2">
            </TabPane>
            <TabPane label="广告" name="3">
            </TabPane>
        </Tabs>
                <KeepAlive :include="['Pitchers','Campaign','adGroup','Address']">
                    <Pitchers v-if="tabIndex == 0" ref="tableRef" :searchOptions="searchOptions" :flag="flag" />
                    <Campaign v-if="tabIndex == 1 " ref="tableRef" :searchOptions="searchOptions" :flag="flag" :langList="langList" />
                    <adGroup v-if="tabIndex == 2 " ref="tableRef" :searchOptions="searchOptions" :flag="flag" :langList="langList" />
                    <Address v-if="tabIndex == 3 " ref="tableRef" :searchOptions="searchOptions" :flag="flag" :langList="langList" />
                </KeepAlive>
                <RadioGroup v-model="flag" type="button" style="margin: 20px 0 0 auto" button-style="solid">
                    <Radio :label="1" style="width: 7em;text-align: center;">新用户</Radio>
                    <Radio :label="2" style="width: 7em;text-align: center;">染色用户</Radio>
                </RadioGroup>
    </Card>
</template>

<script>
import Pitchers from './components/pitchers/index.vue'
import Campaign from './components/campaign/index.vue'
import adGroup from './components/adGroup/index.vue'
import Address from './components/address/index.vue'
import { getCampainInitNew as getCampainInit, getPersonInit, getLang } from '@/api/data'
export default {
    name: 'PitcherNew',
    components:{
        Pitchers,
        Campaign,
        adGroup,
        Address
    },
    data(){
        return {
            tabIndex: '1',
            flag: 1,
            searchOptions: {
                campaign: [],
                person: []
            },
            langList: [],
            extraData: {},
            selectOption: []
        }
    },
    provide(){
        return {
            parent: this
        }
    },
    // watch: {
    //     tabIndex:{
    //         handler(){
    //             this.$nextTick(()=>{
    //                 this.$refs.tableRef.$nextTick(()=>{
    //                     const scroll = document.querySelector(".ivu-table-body");
    //                     const fixed = document.querySelector(".ivu-table-fixed-body");
    //                     console.log(scroll);
                        
    //                     // 监听滚轮
    //                     scroll &&
    //                         scroll.addEventListener(
    //                         "mousewheel",
    //                         (e) => {
    //                             if (scroll.scrollLeft <= 0 && e.deltaX < 0) {
    //                                 e.preventDefault();
    //                             }
    //                         },
    //                         {
    //                             passive: false,
    //                         }
    //                         );
    //                     fixed &&
    //                         fixed.addEventListener("wheel", (e) => {
    //                         e.preventDefault();
    //                         });
    //                 })
    //             })
    //         },
    //         immediate: true
    //     }
    // },
    methods: {
        handleGetDataInit() {
            // getCampainInit({
            //     current: 1,
            //     size: 200
            // }).then(r => {
            //     this.searchOptions.campaign = r.data.records
            // })
            getPersonInit().then(r => {
                this.searchOptions.person = r.data.records
            })
        },
        changeTab(e){
            this.extraData = {}
        },
        handleGetLang(){
            getLang({
                current:1,
                size: 1000,
            }).then(r=>{
                this.langList = r.data.records
            })
        }
    },
    created(){
        this.handleGetDataInit()
        this.handleGetLang()
        
        this.flag = localStorage.getItem('user-campaign-flag')?Number(localStorage.getItem('user-campaign-flag')):1
    },
    
}
</script>

<style lang="less" scoped>
.layout-card {
    /deep/ .ivu-card-body {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
}
</style>